import React, { Component } from 'react'
import HeaderComponent from '../../shared/components/header/headerComponent'
import TopSubMenuComponent from '../../shared/components/header/topSubMenuComponent'
import FooterComponent from '../../shared/components/footer/footerComponent'

class QuizLayout extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }
    componentDidMount() {
    }
    render() {
        return (
            <React.Fragment>
                <HeaderComponent />
                <TopSubMenuComponent />
                {this.props.children}
                <FooterComponent />
            </React.Fragment>
        )
    }
}

export default QuizLayout;